import { render, staticRenderFns } from "./AvukatKimlikKartiForm.vue?vue&type=template&id=65aa824f"
import script from "./AvukatKimlikKartiForm.vue?vue&type=script&lang=ts"
export * from "./AvukatKimlikKartiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports